import Dayjs from 'dayjs';

const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const isOutOfWorktime = (classtalkUser) => {
  const workdays = classtalkUser?.workdays;
  if (!workdays) return false;

  const now = Dayjs();
  const today = DAYS[now.day()];
  const workday = workdays.find((d) => d.day === today);

  if (!workday || !workday.available) return true;

  const currentTime = now.format('HH:mm');
  return currentTime < workday.startTime || currentTime >= workday.endTime;
};
